
import React, { useState, useEffect } from 'react';
import { AppSettings, Employee } from '../types';

interface HeaderProps {
  appSettings: AppSettings;
  currentUser: Employee | null;
  allUsers: Employee[];
  onSetCurrentUser: (employeeId: string) => void;
}

export const Header: React.FC<HeaderProps> = ({ appSettings, currentUser, allUsers, onSetCurrentUser }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timerId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timerId);
  }, []);

  const formatTime = (date: Date) => {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; 
    const strMinutes = minutes < 10 ? '0' + minutes : minutes;
    const strSeconds = seconds < 10 ? '0' + seconds : seconds; // Corrected: seconds < 10
    return `${hours}:${strMinutes}:${strSeconds} ${ampm}`;
  };

  return (
    <header className="bg-[var(--color-primary)] text-white p-4 shadow-md flex justify-between items-center no-print sticky top-0 z-50 h-[var(--header-height,64px)]">
      <div className="flex items-center">
        {appSettings.logoBase64 ? (
          <img src={appSettings.logoBase64} alt={`${appSettings.companyName} Logo`} className="h-8 mr-3 object-contain" />
        ) : (
          <h1 className="text-xl font-bold">{appSettings.companyName}</h1>
        )}
        
      </div>
      <div className="flex items-center space-x-4">
        <div className="text-sm text-right">
          <div className="font-medium">{formatTime(currentTime)}</div>
          <div className="text-xs text-slate-300">{currentTime.toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</div>
        </div>
        {currentUser && (
          <div className="relative group">
             <select
                value={currentUser.id}
                onChange={(e) => onSetCurrentUser(e.target.value)}
                className="bg-transparent text-white text-sm font-medium appearance-none cursor-pointer focus:outline-none py-1 px-2 rounded-md hover:bg-white hover:bg-opacity-10"
                aria-label="Switch user"
              >
              {allUsers.filter(u => u.status === 'Active').map(user => (
                <option key={user.id} value={user.id} className="text-black bg-white">
                  {user.name} ({user.role})
                </option>
              ))}
              {allUsers.filter(u => u.status === 'Inactive').length > 0 && <option disabled className="text-slate-500 bg-slate-100">-- Inactive Users --</option>}
              {allUsers.filter(u => u.status === 'Inactive').map(user => (
                 <option key={user.id} value={user.id} className="text-black bg-white">
                  {user.name} ({user.role})
                </option>
              ))}
            </select>
             <div className="absolute right-0 top-1/2 transform -translate-y-1/2 text-white pointer-events-none pr-1">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" strokeWidth={2} stroke="currentColor" className="w-3 h-3">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
